export default __webpack_public_path__ + "static/media/OK.6969c5b9.svg";